import { AutenticationService } from './../../../autentication/autentication.service';
import { RenameAccount } from './../model/rename-account';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../../shared/EventTypes';
import { RenameYourAccountEventType } from '../rename-your-account.event.type';
import { RenameYourAccountService } from '../rename-your-account.service';
import { Auth } from '../../../autentication/Auth';
import { ThemeService } from '../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-rename-account-form',
	templateUrl: './rename-account-form.component.html',
	styleUrls: ['./rename-account-form.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RenameAccountFormComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited: boolean;
	@Input() renameAccountData: RenameAccount;
	@Output() onSetForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	private view = '[data-component="rename-account-form"]';
	private sendConfirmedRename = false;
	public formAccountName: FormGroup;
	public formSignature: FormGroup;
	public inputToResetPass: any;
	public active = false;
	public disabled = false;
	public isAttendant = false;

	constructor(
		private formBuilder: FormBuilder,
		private renameYourAccountService: RenameYourAccountService,
		private themeService: ThemeService,
		private autenticationService: AutenticationService ) {
	}

	ngOnInit() {
		this.formAccountName = this.formBuilder.group({
			accountName: ['', [Validators.required]],
		});

		this.showStepButtons.emit(false);

		this.isAttendant = this.themeService.isAttendant();

		AppEventDispatcher.listen( RenameYourAccountEventType.STEPS.RENAME_ACCOUNT_RESET, () => {
			this.inputToResetPass = this.formAccountName.get('formAccountName');
			this.onSetForm.emit(this.formAccountName);
			this.active = true;
			this.show();
		});

		AppEventDispatcher.listen(RenameYourAccountEventType.SEND.RENAME_ACCOUNT_SEND, data => {
			this.send();
		});
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});

				clearInterval(interval);
			}

		}, 10);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	addAuthToken() {
		Auth.passToken = this.formSignature.value.token ? this.formSignature.value.token : '';
		Auth.assinaturaEletronica = this.formSignature.value.eletronicSignature ? this.formSignature.value.eletronicSignature : '';
	}

	send() {

		this.submited = true;
		if (this.formSignature.valid) {

			this.preload(true);
			this.submited = false;
			this.disabled = true;

			let time = 1;
			const timeLoader = setInterval(() => {
				time++;
			}, 1000);

			this.addAuthToken();

			this.autenticationService.sendDigitalSignature(this.formSignature.value.eletronicSignature).subscribe(data => {
				if (data.Sucesso) {
					this.preload(true);

					let secondTime = 1;
					const secondTimeLoader = setInterval(() => {
						secondTime++;
					}, 1000);

					this.renameYourAccountService.renameAccount(this.formAccountName.value).subscribe(dataForm => {

						if (dataForm.Sucesso) {
							this.renameAccountData.success = true;
							this.renameAccountData.message = 'Nome da sua conta foi alterado com sucesso.';
						} else {
							this.renameAccountData.success = false;
							this.renameAccountData.message = dataForm.Mensagem;
						}

						this.checkAfterSend(secondTimeLoader, secondTime);
						this.disabled = false;
						this.hide();


					}, error => {
						this.checkAfterSend(secondTimeLoader, secondTime);
						this.disabled = false;

						if (error.error.Tipo !== 'tokenDatablinkValidado') {
							this.hide();
							this.renameAccountData.success = false;
							this.renameAccountData.message = error.error.Mensagem;
						} else {
							AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
							AppEventDispatcher.dispatch(RenameYourAccountEventType.ERROR, { step: RenameYourAccountEventType.SEND.RENAME_ACCOUNT_SEND });
						}

					});
				}

			}, error => {
				this.preload(false);
				this.disabled = false;
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				AppEventDispatcher.dispatch(RenameYourAccountEventType.ERROR, { step: RenameYourAccountEventType.SEND.RENAME_ACCOUNT_SEND });
			});

		}
	}

	hide() {
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(RenameYourAccountEventType.STEPS.RENAME_ACCOUNT_WARNING, { show: true });

			TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RenameYourAccountEventType.SEND.RENAME_ACCOUNT_SEND);
		AppEventDispatcher.removeListener( RenameYourAccountEventType.STEPS.RENAME_ACCOUNT_RESET);
	}

	setInput(input) {
		this.inputToResetPass = this.formAccountName.get('formAccountName');
	}

	onSetSignatureForm(form: FormGroup) {
		this.formSignature = form;

		if (this.sendConfirmedRename) {
			this.send();
		}
	}

	checkAfterSend(timeLoader, time) {

		if (time > 3) {
			this.preload(false);
		}	else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
			});
		}
		clearInterval(timeLoader);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="rename-account-form"] .content', show: active, delay: delay});
	}

	public getMessageConfirmedRename(message: boolean) {
		this.sendConfirmedRename = message;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rename-your-account/rename-account-form/rename-account-form.component.ts